export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";